import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// delete this directory when cleaning up sv-17_migrate_software_form_routes_to_entrypoint

export const LazyFormSubmitEmbedView = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-form-submit-embed", jiraSpaEntry: "async-software-form-submit-embed" */ '@atlassian/jira-spa-apps-software-form-submit-embed/src/index-old'
		),
);

export const FormSubmitEmbedPage = () => (
	<LazyPage
		Page={LazyFormSubmitEmbedView}
		pageId="async-software-form-submit-embed"
		shouldShowSpinner
	/>
);
